import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function MissedVideoCallIcon(props: IconProps) {
    return <Icon {...props} iconKey={"missed_video_call"}/>
}
